import React from 'react'
import { connect } from 'react-redux'
import PunktemeldungListItem from './PunktemeldungListItem';
import { getEFNInEingabe } from '../store/punkteMeldung/commonUtils';

export const ListOfPunktemeldungen = (props) => {
	const {showLernerfolg, showTeilnahmedatum,
		classNamePunktemeldungWithRefPunkte,
		punkteMeldungen, vnr, punkteBasis, punkteLernerfolg} = props
	return(
		<div className = {props.className}>
			<ul className="list-group">
				{punkteMeldungen.map((punktemeldung, index) => <PunktemeldungLI key={index} vnr = {vnr}
				className = {punktemeldung.punkte_referent > 0?classNamePunktemeldungWithRefPunkte:""}
				showTeilnahmedatum={showTeilnahmedatum} showLernerfolg={showLernerfolg} punktemeldung={punktemeldung} punkteBasis={punkteBasis} punkteLernerfolg={punkteLernerfolg}></PunktemeldungLI>)}

			</ul>
		</div>
	)
}

const mapStateToProps = (state, ownProps) => {
	return{
		istInEingabe: ownProps.punktemeldung.efn === getEFNInEingabe(state, ownProps.vnr)
	}
}
const PunktemeldungLI = connect(mapStateToProps)(PunktemeldungListItem)